const catalogPhoto = () => {
    document.querySelectorAll('.catalog-photo').forEach((imagesBlock) => {
        imagesBlock.addEventListener('mouseover', (event) => {
            const target = event.target;

            // Проверяем, что целевой элемент имеет класс 'catalog-photo__item'
            if (target.classList.contains('catalog-photo__item')) {
                const images = Array.from(target.parentNode.querySelectorAll('.catalog-photo__item'));

                // Убираем класс 'catalog-photo__item_selected' у всех изображений
                images.forEach(img => img.classList.remove('catalog-photo__item_selected'));

                // Добавляем класс 'catalog-photo__item_selected' только для текущего изображения
                target.classList.add('catalog-photo__item_selected');

                // Обновляем источник изображения
                const parent = target.closest('.catalog-photo');
                const mainImage = parent.querySelector('img');
                if (mainImage) {
                    mainImage.src = target.dataset.dopSrc;
                }
            }
        });
    });
};

export default catalogPhoto;
